
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DistributionHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareclasscode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DistributionHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fundid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareclasscode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareclasscode"}}},{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asofdatestd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incmdistrecorddate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incmdistexdivdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reinvstmntdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incmdistexpayabledate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainrecorddate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainexdivdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainreinvestmentdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainpayabledate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reinvstmntamt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainamtlongterm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capgainamtshortterm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incmdistamt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxexemptincmamt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returnofcapitalamt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totaldistamtmth"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":681}};
    doc.loc.source = {"body":"query DistributionHistory(\n  $fundid: String!\n  $shareclasscode: String!\n  $countrycode: String!\n  $languagecode: String!\n) {\n  DistributionHistory(\n    fundid: $fundid\n    shareclasscode: $shareclasscode\n    countrycode: $countrycode\n    languagecode: $languagecode\n  ) {\n    distribution {\n      asofdatestd\n      incmdistrecorddate\n      incmdistexdivdate\n      reinvstmntdate\n      incmdistexpayabledate\n      capgainrecorddate\n      capgainexdivdate\n      capgainreinvestmentdate\n      capgainpayabledate\n      reinvstmntamt\n      capgainamtlongterm\n      capgainamtshortterm\n      incmdistamt\n      taxexemptincmamt\n      returnofcapitalamt\n      totaldistamtmth\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DistributionHistory"] = oneQuery(doc, "DistributionHistory");
        
